import { useTranslation } from 'react-i18next'
import Bredcrumb from '../../HomeMain/Bredcrumb'
import Giftcard from '../../HomeMain/Giftcard'

const Main = () => {
  const { t } = useTranslation()
  return (
    <>
      <Bredcrumb title={t('pages.giftcard.title')} subtitle={t('pages.giftcard.subtitle')} />
      <div className="pricing-block">
        <Giftcard />
      </div>
    </>
  )
}

export default Main
